import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, onMounted } from "vue";
import { UserMasterSearchRequest } from "@/models/user-master/UserMasterRequest";
import UserMasterRegist from "./UserMasterRegist.vue";
import { UserMaster } from "@/models/user-master/UserMasterResponse";
import { useApi } from "@/plugins/api/api";
import AffiliationAutocomplete from "@/components/input/AffiliationAutocomplete.vue";
import ValidSelect from "@/components/input/ValidSelect.vue";

type Props = {
  value?: UserMasterSearchRequest;
};
type Emits = {
  (e: "input", val: UserMasterSearchRequest): void;
  (e: "add"): void;
  (e: "search", val: UserMaster[]): void;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'UserMasterSearch',
  props: {
    value: { default: () => ({}) }
  },
  emits: ["input", "add", "search"],
  setup(__props: any, { expose, emit: emits }: { emit: ({
  (e: "input", val: UserMasterSearchRequest): void;
  (e: "add"): void;
  (e: "search", val: UserMaster[]): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { value: UserMasterSearchRequest };

const { $post, Paths } = useApi();




const modelValue = computed({
  get: () => props.value,
  set: val => emits("input", val)
});

const isOpen = ref(false);

const getUserMaster = async () => {
  const response = await $post<UserMaster[]>(
    Paths.userMaster.default,
    modelValue.value
  );
  return response;
};

const onAdd = () => {
  isOpen.value = true;
};

const onSearch = async () => {
  const result = await getUserMaster();
  if (result) {
    emits("search", result);
  }
};

onMounted(async () => {
  await onSearch();
});

expose({
  onSearch
});

return { __sfc: true,$post, Paths, props, emits, modelValue, isOpen, getUserMaster, onAdd, onSearch, UserMasterRegist, AffiliationAutocomplete, ValidSelect }
}

})